import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "opModal" };
const _hoisted_2 = {
    key: 0,
    class: "pageTitle"
};
const _hoisted_3 = {
    key: 1,
    class: "pageTitle"
};
const _hoisted_4 = { class: "form-group" };
const _hoisted_5 = { class: "form-group" };
const _hoisted_6 = { class: "form-group" };
const _hoisted_7 = { class: "form-group" };
const _hoisted_8 = {
    key: 0,
    class: "form-group"
};
const _hoisted_9 = { class: "form-group" };
const _hoisted_10 = { class: "text-right" };
const _hoisted_11 = {
    key: 1,
    type: "submit",
    class: "btn btn-green"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_mini_spinner = _resolveComponent("mini-spinner");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.$store.state.isCliente())
            ? (_openBlock(), _createElementBlock("h3", _hoisted_2, "Referral"))
            : (_openBlock(), _createElementBlock("h3", _hoisted_3, "Segnala un amico")),
        (!_ctx.referral)
            ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 2 }))
            : (_openBlock(), _createElementBlock("form", {
                key: 3,
                onSubmit: _cache[6] || (_cache[6] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.save && _ctx.save(...args)), ["prevent", "stop"])),
                class: "horizontal"
            }, [
                _createElementVNode("div", _hoisted_4, [
                    _cache[7] || (_cache[7] = _createElementVNode("label", null, "Nome", -1)),
                    _withDirectives(_createElementVNode("input", {
                        class: "form-control",
                        type: "text",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.referral.name) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.referral.name]
                    ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", null, "Cognome", -1)),
                    _withDirectives(_createElementVNode("input", {
                        class: "form-control",
                        type: "text",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.referral.surname) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.referral.surname]
                    ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", null, "Email", -1)),
                    _withDirectives(_createElementVNode("input", {
                        class: "form-control",
                        type: "email",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.referral.email) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.referral.email]
                    ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _cache[10] || (_cache[10] = _createElementVNode("label", null, "Telefono", -1)),
                    _withDirectives(_createElementVNode("input", {
                        class: "form-control",
                        type: "text",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.referral.telephone) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.referral.telephone]
                    ])
                ]),
                (!_ctx.$store.state.isCliente())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _cache[12] || (_cache[12] = _createElementVNode("label", null, "Stato", -1)),
                        _withDirectives(_createElementVNode("select", {
                            class: "form-control",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.referral.stato) = $event))
                        }, [
                            _cache[11] || (_cache[11] = _createElementVNode("option", {
                                disabled: "",
                                value: ""
                            }, "Stato referral", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stati, (item, i) => {
                                return (_openBlock(), _createElementBlock("option", { key: i }, _toDisplayString(item), 1));
                            }), 128))
                        ], 512), [
                            [_vModelSelect, _ctx.referral.stato]
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                    _cache[13] || (_cache[13] = _createElementVNode("label", null, "Note", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                        class: "form-control",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.referral.note) = $event)),
                        rows: "5",
                        placeholder: "Indica l'orario in cui possiamo contattarlo e altre informazioni utili"
                    }, null, 512), [
                        [_vModelText, _ctx.referral.note]
                    ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                    (_ctx.saving)
                        ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
                        : (_openBlock(), _createElementBlock("button", _hoisted_11, " Salva "))
                ])
            ], 32))
    ]));
}
